import Flex from "../Flex/Flex";
import styles from "./Progress.module.css";

export default function Progress(props: { progressPercentage: number } = { progressPercentage: 33.3 }) {
  return (
    <Flex align="center" className={styles.outer}>
      <div className={styles.inner} style={{width:`${props.progressPercentage}%`}}></div>
    </Flex>
  );
}
